// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V2$Linear from "./V2.res.js";
import * as M22$Linear from "./M22.res.js";
import * as V2f$Linear from "./V2f.res.js";

let zero = M22$Linear.fill(0);

function scalar(value) {
  return [
    [
      value,
      0
    ],
    [
      0,
      value
    ]
  ];
}

let identity_0 = [
  1,
  0
];

let identity_1 = [
  0,
  1
];

let identity = [
  identity_0,
  identity_1
];

function scale(m, s) {
  return M22$Linear.map(m, e => e * s);
}

function determinant(param) {
  let match = param[1];
  let match$1 = param[0];
  return match$1[0] * match[1] - match$1[1] * match[0];
}

function inverse(mat) {
  let match = mat[1];
  let match$1 = mat[0];
  return scale([
    [
      match[1],
      - match$1[1]
    ],
    [
      - match[0],
      match$1[0]
    ]
  ], 1 / determinant(mat));
}

let jsonCodec = M22$Linear.jsonCodec(Jzon.float);

function v2f(a, b) {
  return V2$Linear.map(a, row => V2f$Linear.dot(row, b));
}

function m22f(a, b) {
  let bcols = M22$Linear.transpose(b);
  return V2$Linear.map(a, row => V2$Linear.map(bcols, col => V2f$Linear.dot(row, col)));
}

let Mult = {
  v2f: v2f,
  m22f: m22f
};

function rotation(angle) {
  return [
    [
      Math.cos(angle),
      -1 * Math.sin(angle)
    ],
    [
      Math.sin(angle),
      Math.cos(angle)
    ]
  ];
}

let Transformation = {
  rotation: rotation
};

let det = determinant;

export {
  zero,
  scalar,
  identity,
  scale,
  determinant,
  det,
  inverse,
  jsonCodec,
  Mult,
  Transformation,
}
/* zero Not a pure module */
